exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.file-tree-browser-toggle-wrapper[data-v-522a1b04] {\n  display: contents; /* Removes wrapper from layout flow */\n}\n.file-browser-toggle-tooltip .tooltip-inner[data-v-522a1b04] {\n  max-width: 210px;\n}\n", ""]);

